import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  SpinnerButton,
  Typography,
} from '@forgeglobal/design-framework'
import React, { useState } from 'react'

import { CampaignBidsTable } from './CampaignBidsTable'
import { CampaignParticipantsTable } from './CampaignParticipantsTable'

interface CampaignParticipantsDetailProps {
  offeringId: string
}

export const CampaignParticipantsDetail: React.FC<CampaignParticipantsDetailProps> = ({ offeringId }) => {
  const [selectedTableType, setSelectedTableType] = useState('all')

  const handleChange = (_: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => {
    if (value && value !== selectedTableType) {
      setSelectedTableType(value)
    }
  }

  return (
    <Card>
      <CardHeader
        action={
          <Box p={2}>
            <ButtonGroup
              exclusive
              onChange={handleChange}
              value={selectedTableType}
              options={[
                { label: 'With bids', value: 'bids' },
                { label: 'All', value: 'all' },
              ]}
              size="large"
            />
          </Box>
        }
        title={
          <Typography variant="h6" color="secondary">
            Participants Detail
          </Typography>
        }
      />
      <CardContent color="light">
        {selectedTableType === 'all' ? (
          <CampaignParticipantsTable offeringId={offeringId} />
        ) : (
          <CampaignBidsTable offeringId={offeringId} />
        )}
      </CardContent>
    </Card>
  )
}

interface LoadingRowProps {
  isLoading: boolean
}

// TODO - add loading state to design framework CardTable component and then refactor this
export const LoadingRow: React.FC<LoadingRowProps> = ({ isLoading }) => {
  return isLoading ? (
    <Card>
      <CardHeader
        title={
          <SpinnerButton variant="text" color="primary" type="submit" fullWidth loading={true} caption="Loading" />
        }
      />
    </Card>
  ) : null
}
